import { Controller } from "@hotwired/stimulus"
import { subscribeToMarketPrices } from "../channels/market_prices_channel"

export default class extends Controller {
  static targets = ["marketItem"]
  static values  = {
    selectedSlug:     String,
    marketIds:        Array,
    eventSlug:        String,
    tradingFrameBase: String,
    sectionsFrameBase: String
  }

  connect() {
    this.subscriptions = []
    this.updateHighlight()
    this.subscribeToAllMarkets()
  }

  disconnect() {
    this.subscriptions.forEach(sub => sub.unsubscribe())
    this.subscriptions = []
  }

  select(event) {
    const slug = event.currentTarget.dataset.marketSlug
    if (!slug || slug === this.selectedSlugValue) return

    this.selectedSlugValue = slug
    this.updateHighlight()
    this.reloadFrames(slug)
    this.updateUrl(slug)
  }

  updateHighlight() {
    this.marketItemTargets.forEach(item => {
      const selected = item.dataset.marketSlug === this.selectedSlugValue
      item.classList.toggle("ring-2", selected)
      item.classList.toggle("ring-accent", selected)
    })
  }

  reloadFrames(slug) {
    if (this.hasTradingFrameBaseValue) {
      const frame = document.getElementById("trading-panel")
      if (frame) frame.setAttribute("src", `${this.tradingFrameBaseValue}${slug}/panel`)
    }
    if (this.hasSectionsFrameBaseValue) {
      const frame = document.getElementById("event_market_sections")
      if (frame) frame.setAttribute("src", `${this.sectionsFrameBaseValue}?mercado=${slug}`)
    }
  }

  updateUrl(slug) {
    if (!this.hasEventSlugValue) return
    const url = new URL(window.location.href)
    url.searchParams.set("mercado", slug)
    window.history.replaceState({}, "", url.toString())
  }

  subscribeToAllMarkets() {
    this.marketIdsValue.forEach(id => {
      const sub = subscribeToMarketPrices(id, {
        received: data => this.updateRowProbability(id, data)
      })
      this.subscriptions.push(sub)
    })
  }

  updateRowProbability(marketId, data) {
    const item = this.marketItemTargets.find(el => el.dataset.marketId === marketId)
    if (!item) return

    const outcome = item.dataset.featuredOutcome
    const prob    = outcome === "yes" ? data.probability_yes : data.probability_no
    const el      = item.querySelector("[data-probability]")
    if (el) el.textContent = `${(prob * 100).toFixed(0)}%`
  }
}
